import { Card, CardContent } from "@/components/uiDir/card";
import { UserPlus, Edit3, Smartphone, Share2 } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      icon: <UserPlus className="w-8 h-8" />,
      title: "Sign Up",
      description: "Create your account with your student ID and program details.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: <Edit3 className="w-8 h-8" />,
      title: "Build Your Portfolio",
      description: "Add projects, skills, resume, and customize your theme.",
      color: "text-secondary",
      bgColor: "bg-secondary/10",
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: "Link to NFC/QR",
      description: "Connect your portfolio to your student ID or generate a QR code.",
      color: "text-accent",
      bgColor: "bg-accent/10",
    },
    {
      icon: <Share2 className="w-8 h-8" />,
      title: "Share Instantly",
      description: "Let people tap your ID or scan your QR to view your work.",
      color: "text-success",
      bgColor: "bg-success/10",
    },
  ];

  return (
    <section id="how-it-works" className="py-14 sm:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16 animate-slide-up">
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            How It Works{" "}
            {/* <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 bg-clip-text text-transparent">
              ?
            </span> */}
          </h2>
          <p className="text-xl bg-gradient-to-r from-orange-600 to-red-500 bg-clip-text text-transparent max-w-2xl mx-auto">
            From signup to sharing, it takes less than 10 minutes
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Connector Line */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-border to-transparent -translate-y-1/2 z-0" />
                )}
                
                <Card
                  className="glass-card relative z-10 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-slide-up text-center"
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <CardContent className="p-5 sm:p-6 flex flex-col items-center text-center">
                    {/* Step Number */}
                    <div className="text-4xl text-primary font-bold font-heading text-muted-foreground/20 mb-4">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    {/* Icon */}
                    <div className={`inline-flex p-3 rounded-xl ${step.bgColor} ${step.color} mb-4`}>
                      {step.icon}
                    </div>
                    
                    {/* Content */}
                    <h3 className="font-heading text-xl font-semibold mb-2">
                      {step.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;